import React, { useEffect, useState } from 'react';
import { StyledDiscoverTeamSection } from './DiscoverTeamSection.style';
import agentService from '../../../services/agentService';
import Select from '../../Select';
import { useContextHook } from 'use-context-hook';
import { AuthContext } from '../../../Context/authContext';
import teamService from '../../../services/teamService';
import DiscoverTeamCard from './DiscoverTeamCard';
import Loaders from '../../Loaders';
import Field from '../../Field';
import { useQuery } from '@tanstack/react-query';

const DiscoverTeamSection = () => {
  const [filterName, setFilterName] = useState(null);
  const [searchQuery, setSearchQuery] = useState({
    team_type: 'admin_created',
    domain_id: '',
  });
  const [agentsCategory, setAgentsCategory] = useState([]);

  const getAllTeamsData = useQuery({
    queryKey: ['admin_teams', searchQuery],
    queryFn: () => teamService.getFilteredTeamList(searchQuery),
    staleTime: Infinity,
  });

  const getFeedaCategory = async () => {
    const resp = await agentService.getAllfeedaAgentsCategory('admin_created');
    const restructuredDataForSelect = resp?.domains?.map(elem => ({ label: elem?.domain, value: elem?.domain_id }));
    setAgentsCategory([{ label: 'All', value: '' }, ...restructuredDataForSelect]);
  };
  useEffect(() => {
    getFeedaCategory();
  }, []);
  return (
    <StyledDiscoverTeamSection>
      <div className="inputs-wrapper">
        <div className="select-wrapper">
          <Select
            options={agentsCategory}
            placeholder="All"
            onChange={({ target }) => setSearchQuery(prev => ({ ...prev, domain_id: target?.value?.value }))}
          />
        </div>
        <Field
          type="text"
          placeholder="Search team by name"
          name="searchAgent"
          onChange={({ target }) => setFilterName(target?.value)}
        />
      </div>

      <div className="cards-wrap">
        {getAllTeamsData?.isPending ? (
          <Loaders viewLoader />
        ) : (
          <DiscoverTeamCard teamCardsData={getAllTeamsData?.data?.teams} filterName={filterName} />
        )}
      </div>
    </StyledDiscoverTeamSection>
  );
};

export default DiscoverTeamSection;
